import { UNAUTHORIZED_PATHS } from '~/components/page/Auth/constants';

const isUnauthorizedPath = (pathname: string): boolean => {
  for (const path of UNAUTHORIZED_PATHS) {
    if (pathname.startsWith(path)) return true;
  }
  return false;
};

export default isUnauthorizedPath;
